module.exports = __webpack_public_path__ + "static/img/MK@3x.72043c62.jpg";